import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import { store } from './store/configureStore';
import registerServiceWorker from './registerServiceWorker'
import Root from './pages/Root'
import { BrowserRouter as Router } from 'react-router-dom'

const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(<Provider store={store}>
  <Router>
    <Root />
  </Router>
</Provider>);

registerServiceWorker()